import { useContext, useEffect, useState } from 'react'
import { clsx } from 'clsx'
import { useTranslation } from '../../../hooks'
import ToolbarContext from './ToolbarContext'
import FieldBoundaryContext from '../../../DataContext/FieldBoundary/FieldBoundaryContext'
import { Hr } from '../../../../../elements'
import { Flex, FormStatus } from '../../../../../components'
import type { SpaceAllProps } from '../../../../../components/Space'
import Space from '../../../../../components/Space'

export type FormSectionToolbarProps = SpaceAllProps & {
  onEdit?: () => void
  onDone?: () => void
  onCancel?: () => void
}

export default function Toolbar(props: FormSectionToolbarProps) {
  const { errorInSection } = useTranslation().SectionEditContainer
  const { children, className, onEdit, onDone, onCancel, ...rest } = props

  const { hasError, hasVisibleError } =
    useContext(FieldBoundaryContext) || {}
  const [showError, setShowError] = useState(false)

  useEffect(() => {
    if (showError && !hasError) {
      setShowError(false)
    }
  }, [hasError, showError])

  return (
    <Space
      className={clsx('dnb-forms-section-toolbar', className)}
      {...rest}
    >
      <Hr space={0} />

      <ToolbarContext value={{ setShowError, onEdit, onDone, onCancel }}>
        <Flex.Horizontal top="x-small" gap="large">
          {children}
        </Flex.Horizontal>
      </ToolbarContext>

      <FormStatus
        show={showError && hasVisibleError}
        shellSpace={{ top: 'x-small' }}
        noAnimation={false}
      >
        {errorInSection}
      </FormStatus>
    </Space>
  )
}
